"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var permissions_json_1 = __importDefault(require("../../../permissions.json"));
var roles_json_1 = __importDefault(require("../../../roles.json"));
var descriptions_1 = __importDefault(require("../../config/descriptions"));
var event_bus_1 = require("../../event-bus");
exports.default = vue_1.default.extend({
    name: "permissions-group",
    props: {
        permissions: {
            type: Array,
            required: true
        },
        rolePermissions: {
            type: Array,
            required: true
        },
        role: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            allPermissions: permissions_json_1.default,
            allRoles: roles_json_1.default,
            descriptions: descriptions_1.default.permissions
        };
    },
    methods: {
        getDescription: function (permission) {
            if (this.descriptions.hasOwnProperty(permission)) {
                return this.descriptions[permission];
            }
            return permission;
        },
        isCheckboxDisabled: function () {
            return (this.role.name === this.allRoles.superAdministrator);
        },
        onCheckboxChange: function (permission, assign) {
            event_bus_1.EventBus.$emit(event_bus_1.events.role.permission.update, {
                id: this.role.id,
                permission: permission,
                assign: assign
            });
        }
    }
});
